import { Controller } from "@hotwired/stimulus"

// Location filter chips on /events. Filters rows by data-location attr.
// ALL always shows everything; MADHAPUR shows rows matching or "both".
export default class extends Controller {
  static targets = ["chip", "row"]

  select(e) {
    const key = e.currentTarget.dataset.filterKey
    this.chipTargets.forEach(c => {
      const active = c.dataset.filterKey === key
      c.classList.toggle("active", active)
      c.setAttribute("aria-pressed", active ? "true" : "false")
    })
    this.rowTargets.forEach(r => {
      const loc = (r.dataset.location || "").toLowerCase()
      const show = key === "all" || loc === "" || loc === key
      r.hidden = !show
    })
  }
}
